<template>

<app-router :to="{name: ($isPatreon) ? 'SessionPatreonAccess' : 'CommunityAccess'}" class="inbox" v-tooltip="'Early access'">

    <div class="inbox-icon"><i class="fa-solid fa-flask"></i></div>

</app-router>

</template>

<script>

export default {

}

</script>

<style scoped>

.inbox {
    height: 64px;
    padding: 8px 0px;
    display: flex;
    align-items: center;
    margin-left: 10px;
    cursor: pointer;
}

.is-mobile .inbox {
    height: 48px;
    margin-left: 4px;
}

.inbox-count {
    background-color: #f64b4b;
    position: absolute;
    right: 0px;
    top: 0px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.inbox-icon {
    color: rgba(255, 255, 255, 1);
    background-color: #1e3648;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
}

.inbox.router-link-active .inbox-icon {
    background-color: #ffc563;
    color: #082534;
}

.is-mobile .inbox-icon {
    height: 32px;
    width: 32px;
    line-height: 32px;
}

</style>
